import { memo } from 'react'
import { clsx } from 'clsx'

import css from './DebugInfoTooltip.module.scss'

import Toggle from '@/components/Toggle'

import { APP_VERSION } from '@/constants/changelog'

import type { ControllerProps } from './DebugInfoTooltip.controller'

export type StatusColor = 'yellow' | 'red' | 'green'

export interface ViewProps extends ControllerProps {
  showDebug: boolean
  onShowDebugChange: (showDebug: boolean) => void
  onChangelogNavigate?: () => void
}

const View = memo(function DebugInfoTooltipView({
  environment,
  apiStatus,
  visible,
  showDebug,
  onShowDebugChange,
  onChangelogNavigate,
  className
}: ViewProps) {
  const getValueColorClass = (color: StatusColor) => {
    const colorMap = {
      yellow: css.valueYellow,
      red: css.valueRed,
      green: css.valueGreen
    }
    return colorMap[color]
  }

  const getDotColorClass = (color: StatusColor) => {
    const colorMap = {
      yellow: css.dotYellow,
      red: css.dotRed,
      green: css.dotGreen
    }
    return colorMap[color]
  }

  return (
    <div className={clsx('DebugInfoTooltip', css.root, className, { [`${css.visible}`]: visible })}>
      <div className={css.item}>
        <span className={css.label}>Environment:</span>
        <span className={css.value}>{environment}</span>
      </div>
      <div className={css.item}>
        <span className={css.label}>API Status:</span>
        <span className={clsx(css.value, getValueColorClass(apiStatus.color))}>
          <span className={clsx(css.dot, getDotColorClass(apiStatus.color))} />
          {apiStatus.text}
        </span>
      </div>
      <div className={css.item}>
        <span className={css.label}>App Version:</span>
        <span className={css.value}>{APP_VERSION}</span>
      </div>
      <Toggle
        checked={showDebug}
        onChange={onShowDebugChange}
        label="Show debug information"
        className={css.debugToggle}
      />
      <div className={css.changelogRow}>
        <button type="button" className={css.link} onClick={onChangelogNavigate}>
          View changelog →
        </button>
      </div>
    </div>
  )
})

View.displayName = 'DebugInfoTooltip_View'

export default View
